import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  UserProfileImage,
} from "@/components/ui/avatar";
import { MessageSquareText, Sun, Moon } from "lucide-react";
import { useThemeStore } from "@/store/themeStore";
import { useAuthStore } from "@/store/authStore";
import { useEffect } from "react";
import { useGetUserStatus } from "@/hooks/use-queries";

type SidebarItem = {
  icon: React.ElementType;
  label: string;
  onClick?: () => void;
  active?: boolean;
};

function SidebarButton({ item }: { item: SidebarItem }) {
  const Icon = item.icon;
  return (
    <button
      type="button"
      className={`flex items-center justify-center w-12 h-12 rounded-md hover:bg-white/10 transition-colors ${
        item.active ? "text-white" : "text-white/70"
      }`}
      aria-label={item.label}
      title={item.label}
      onClick={item.onClick}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
}

export function Sidebar() {
  const { theme, toggleTheme } = useThemeStore();
  const { data: user , isSuccess} = useGetUserStatus();

  const items: SidebarItem[] = [
    { icon: MessageSquareText, label: "Chats", active: true },
  ];

  return (
    <aside className="hidden md:flex h-screen w-16 flex-col border-r bg-primary">
      <div className="flex-1 flex flex-col items-center gap-2 py-2">
        {items.map((item) => (
          <SidebarButton key={item.label} item={{ ...item, active: true }} />
        ))}
      </div>
      <div className="p-2 flex items-center justify-center">
        <SidebarButton
          item={{
            icon: theme === "light" ? Moon : Sun,
            label: theme === "light" ? "Dark Mode" : "Light Mode",
            onClick: toggleTheme,
            active: true,
          }}
        />
      </div>
      <div className="p-2 pb-3 flex items-center justify-center">
       {isSuccess && <UserProfileImage userId={user.id} />}
        {/* <Avatar className="h-10 w-10">
          <AvatarImage src={user?.user_image} alt={user?.username} />
          <AvatarFallback>
            {user?.username ? user?.username : "YO"}
          </AvatarFallback>
        </Avatar> */}
      </div>
    </aside>
  );
}

export default Sidebar;
